<template lang="pug">
    .category
        .category-header 
            .category-label {{ label }}
            .counter {{ criteria.length }}

        CriterionItem(
            v-for="(criterion, index) in list" 
            :formula="formula"
            :criterion="criterion"
            displayPath
            @onTagClick="$emit('onTagClick', $event)"
        )

        .wrapper-show-more(v-if="this.criteria.length > 5")
            .btn-show-more(
                @click="expanded = !expanded"
            ) {{ expanded ? 'show less' : 'show more' }}
</template> 

<script>
import CriterionItem from './CriterionItem.vue'

export default {
    name: 'SearchResultList',

    components: {
        CriterionItem
    },

    props: {
        criteria: {
            type: Array,
            required: true
        },
        formula: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            expanded: false
        }
    },

    computed: {
        list() {
            if (this.expanded) {
                return this.criteria
            }

            return this.criteria.slice(0, 5)
        }
    }
}
</script>